<template>
    <common-content-spacer height="small">
        <common-page-header :heading="$t('components.locations.update_locations_component.edit_address')"></common-page-header>
        <GMapAutocomplete
            class="edit-location-input"
            :placeholder="$t('components.locations.update_locations_component.enter_address_here')"
            :selectFirstOnEnter="true"
            @click.stop
            @place_changed="setPlace"
        ></GMapAutocomplete>
    </common-content-spacer>
</template>

<script>
    export default {
        methods: {
            setPlace(place) {
                if (place.address_components) {
                    this.emitEvent({ name: 'edit-address', payload: place })
                }
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';

    .edit-location-input {
        outline: none;
        appearance: none;
        border: 1px solid $color--border-input;
        border-radius: $border-radius--base;
        padding: 15px;
        color: $color--txt-base;
        width: 100%;
        height: $height--input;
        font-size: $font-size--form;
        line-height: 20px;
        letter-spacing: $letter-spacing--base;
        transition: trans(border), trans(background), trans(opacity);
        font-family: $font-family--base;

        &:focus {
            border-color: $color--accent-1;
        }
    }
</style>
